type IconMaterialProps = {
  name: string;
};

const IconMaterial = ({ name }: IconMaterialProps) => {
  return <span className="IconMaterial material-symbols-sharp">{name}</span>;
};

export default IconMaterial;
